var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshDoubleArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 7.77778C2.33337 7.77778 2.40617 7.2588 4.515 5.11091C6.62383 2.96303 10.0429 2.96303 12.1518 5.11091C12.8989 5.87191 13.3814 6.80044 13.5991 7.77778M2.33337 7.77778V4.11111M2.33337 7.77778H5.93337M14.3334 10.2222C14.3334 10.2222 14.2606 10.7412 12.1518 12.8891C10.0429 15.037 6.62383 15.037 4.515 12.8891C3.76783 12.1281 3.28539 11.1996 3.06767 10.2222M14.3334 10.2222V13.8889M14.3334 10.2222H10.7334",
    stroke: "#8C8C8C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDoubleArrows);
export default __webpack_public_path__ + "static/media/refresh_double_arrows.d980cf01c10764f4a79709c3f04a3963.svg";
export { ForwardRef as ReactComponent };